if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        Nous recherchons votre colis...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Recherche en cours…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "BE"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat zamiast "introuvable"
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Trop de tentatives
            </div>

            <div class="ee-error-message">
                Vous avez effectué trop de recherches à la suite.
                Veuillez patienter une minute et réessayer.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                La commande a été annulée
            </div>

            <div class="ee-error-message">
                Cette commande a été annulée et ne sera pas traitée.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    Nous préparons votre commande
                </div>

<div class="ee-info-message">


 <br>

    Votre commande a été reçue et est en cours de traitement.

    <br><br>

    Aucun numéro de suivi n'a encore été attribué.
    Une fois votre colis expédié, les informations de suivi seront disponibles sur cette page et par e-mail.

    <br><br>

    Si vous avez d'autres questions concernant votre commande, contactez notre service client.

    <br>

                    <a href="https://euroelectronics.be/pages/contact" class="ee-contact-link">
                        Contactez-nous
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Commande introuvable
                </div>

                <div class="ee-error-message">
                    Nous n'avons trouvé aucune commande correspondant au numéro de commande et à l'adresse e-mail fournis.

                    Veuillez vérifier que les informations ont été saisies correctement et réessayer.
                    <br><br>

                    Si vous avez besoin d'aide, contactez notre service client.
                    <br>

                    <a href="https://euroelectronics.be/pages/contact" class="ee-contact-link">
                        Accéder au formulaire de contact
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Colis trouvé
                        </div>
<div class="ee-result-description">
                            Vous trouverez ci-dessous les informations sur votre colis.
                          
                            Cliquez sur le bouton ci-dessous pour accéder directement au suivi chez le transporteur.
                           
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Numéro de commande
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Numéro de suivi
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Suivre le colis
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Produits commandés (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Une erreur s'est produite
                        </div>

                        <p>
                            Impossible de se connecter au système de suivi.
                            Veuillez réessayer dans quelques instants.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}